document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(
    "#buttons-card-collections .button-collection"
  );
  buttons.forEach((button) => {
    const collectionGroup = button.dataset.collectionButton;
    button.addEventListener("click", function (e) {
      buttons.forEach((btn) => {
        const aux = btn.dataset.collectionButton;
        if (aux === collectionGroup) btn.classList.remove("button-selected");
      });
      e.target.classList.add("button-selected");

      const collections = document.querySelectorAll(
        ".featured-collection--container-card"
      );
      collections.forEach((collection) => {
        const group = collection.dataset.collectionGroup;
        if (group === collectionGroup) collection.classList.add("hidden-card");
      });
      document
        .getElementById(`grid-${e.target.id}`)
        .classList.remove("hidden-card");
    });
  });

  const scrollables = document.getElementsByClassName(
    "product-collection-grid-group"
  );

  let isMouseDown = false;
  let startX;
  let scrollLeft;

  Array.from(scrollables).forEach((scrollable) => {
    scrollable.addEventListener("mousedown", (e) => {
      isMouseDown = true;
      startX = e.pageX - scrollable.offsetLeft;
      scrollLeft = scrollable.scrollLeft;
      scrollable.style.cursor = "grabbing";
    });

    scrollable.addEventListener("mouseleave", () => {
      isMouseDown = false;
      scrollable.style.cursor = "grab";
    });

    scrollable.addEventListener("mouseup", () => {
      isMouseDown = false;
      scrollable.style.cursor = "grab";
    });

    scrollable.addEventListener("mousemove", (e) => {
      if (!isMouseDown) return;
      e.preventDefault();
      const x = e.pageX - scrollable.offsetLeft;
      const walk = (x - startX) * 3; // 3 es la velocidad de desplazamiento
      scrollable.scrollLeft = scrollLeft - walk;
    });
    scrollable.style.scrollBehavior = "smooth";
  });

  const arrowsLeft = document.getElementsByClassName("arrow-left");
  const arrowsRight = document.getElementsByClassName("arrow-right");

  Array.from(arrowsLeft).forEach((arrowLeft) => {
    const scrollable = document.getElementById(
      "scrollable-" + arrowLeft.dataset.scrollable
    );
    arrowLeft.addEventListener("click", () => {
      scrollable.scrollLeft -= 240;
    });
  });
  Array.from(arrowsRight).forEach((arrowRight) => {
    const scrollable = document.getElementById(
      "scrollable-" + arrowRight.dataset.scrollable
    );
    arrowRight.addEventListener("click", () => {
      scrollable.scrollLeft += 240;
    });
  });
});
